import { objectKeysToSnakeCase } from '@myn/shared/src/utils';

import {
  RECOMMENDATIONS_LIST,
  RECOMMENDATIONS_ROOT,
  RECOMMENDATIONS_SETTINGS,
  RECOMMENDATIONS_STATE,
  RECOMMENDATIONS_WARNINGS,
} from '../constants/EndpointConstants.js';
import {
  RecommendationResponse,
  RecommendationsSettings,
  RecommendationStatus,
  RecommendationType,
  RecoSettingsPrioritisationGoal,
} from '../types/Recommendations.js';
import callApi, { ApiResponse } from './callApi.js';

export type GetRecommendationListType = Partial<{
  page: number;
  pageSize: number;
  status: RecommendationStatus;
  dateFrom: string;
  dateTo: string;
  journeyId: number;
}>;

export type AcceptRecommendationType = { id: number };

export type RejectRecommendationType = AcceptRecommendationType & {
  reason?: string;
};

export type ChangeRecommendationSettingsType = {
  journeyId: number;
  parameters: Partial<RecommendationsSettings>;
};

export type GetRecoSettingsNonApplicableSearch = {
  mediaPlanId: number;
  params?: { search: string };
};

export type GetRecoSettingsGoal = {
  journeyId: number;
};
export type RecommendationScenarioType = { id: number };

export const getRecommendations = (
  params?: GetRecommendationListType,
): Promise<ApiResponse<RecommendationResponse>> =>
  callApi(RECOMMENDATIONS_LIST, {
    params: objectKeysToSnakeCase(params!),
  });

export type RecommendationsStateResponse = { activeExists: boolean };
export type RecommendationPublishParams = {
  recommendationId: number;
  status: boolean;
  workspaceId?: number;
};

export const getRecommendationsState = (
  journeyId: number,
): Promise<ApiResponse<RecommendationsStateResponse>> =>
  callApi(RECOMMENDATIONS_STATE, { params: { journey_id: journeyId } });

export const getRecommendation = (
  id: number,
): Promise<ApiResponse<RecommendationType>> =>
  callApi(`${RECOMMENDATIONS_ROOT}/${id}`);

export const acceptRecommendation = ({
  id,
}: AcceptRecommendationType): Promise<ApiResponse<RecommendationType>> =>
  callApi(`${RECOMMENDATIONS_ROOT}/${id}/accept`, {
    method: 'POST',
  });

export const rejectRecommendation = ({
  id,
  reason = '',
}: RejectRecommendationType): Promise<ApiResponse<RecommendationType>> =>
  callApi(`${RECOMMENDATIONS_ROOT}/${id}/reject`, {
    method: 'POST',
    data: JSON.stringify({
      reason,
    }),
  });

export function setRecommendationStatus({
  recommendationId,
  status,
  workspaceId,
}: RecommendationPublishParams) {
  return callApi(
    `${RECOMMENDATIONS_ROOT}/${recommendationId}/show_hide/action`,
    {
      method: 'POST',
      data: JSON.stringify({
        enabled: status,
        workspaceId,
      }),
    },
  );
}

export const getRecommendationsSettings = (
  journeyId: number,
): Promise<ApiResponse<RecommendationsSettings>> =>
  callApi(RECOMMENDATIONS_SETTINGS, { params: { journey_id: journeyId } });

export const changeRecommendationSettings = (
  data: ChangeRecommendationSettingsType,
): Promise<ApiResponse<RecommendationsSettings>> =>
  callApi(RECOMMENDATIONS_SETTINGS, {
    method: 'POST',
    data: objectKeysToSnakeCase(data),
  });

export const getRecommendationsSettingsGoal = ({
  journeyId,
}: GetRecoSettingsGoal): Promise<ApiResponse<RecoSettingsPrioritisationGoal>> =>
  callApi(`${RECOMMENDATIONS_WARNINGS}?journey_id=${journeyId}`);
